import { render, staticRenderFns } from "./ToleranceRefStrip.vue?vue&type=template&id=4582b09e&scoped=true"
import script from "./ToleranceRefStrip.vue?vue&type=script&lang=js"
export * from "./ToleranceRefStrip.vue?vue&type=script&lang=js"
import style0 from "./ToleranceRefStrip.vue?vue&type=style&index=0&id=4582b09e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4582b09e",
  null
  
)

export default component.exports